<template>
  <div class="apply">
    <img :src="require('../../assets/img/logo.png')" alt="">
    <p class="title">活动报名</p>
    <p class="info"><span>活动标题：</span>{{ activityInfo.activityTitle }}</p>
    <p class="info"><span>活动地址：</span>{{ activityInfo.activityAddress }}</p>
    <p class="info"><span>开始时间：</span>{{ activityInfo.startTime }}</p>
    <p class="info"><span>结束时间：</span>{{ activityInfo.endTime }}</p>
    <template v-if="isSuccess">
      <div class="success">
        <i class="el-icon-circle-check" style=""></i><br>
        报名成功 !
      </div>
    </template>
    <template v-else>
      <div class="content">
        <div class="notice">最多报名3人</div>
        <p style="width: 100%;position: relative">
          <span><i class="red-star">*</i>&nbsp;&nbsp;公司名称：</span><br>
          <el-autocomplete
              v-model="joinParams.companyName"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              style="width: 100%"
              @select="handleChangeAuto"
          ></el-autocomplete>
          <el-select
            v-if="false"
            ref="select"
            v-model="joinParams.companyName"
            filterable
            remote
            reserve-keyword
            placeholder=""
            @hook:mounted="cancelReadOnly"
            @visible-change="cancelReadOnly"
            @change="handleChange"
            @blur="blurInput($event)"
            style="width: 100%"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in options"
              :key="item.company_code"
              :label="item.company_name"
              :value="item.company_name">
            </el-option>
          </el-select>
        </p>
        <p style="margin-right: 0;width: 100%;position: relative;margin-top: 10px">
          <span><i class="red-star">*</i>&nbsp;&nbsp;社会信用代码：</span><br>
          <el-input v-model="joinParams.socialCreditCode" />
        </p>
        <div v-for="(item, index) in joinParams.applyUserList" :key="index" class="join-people">
          <p v-for="(value, key) in item" :key="key" class="join-item">
            <span><i class="red-star">*</i>&nbsp;&nbsp;{{ joinParamMapping[key] }}：</span><br>
            <el-input v-model="item[key]" :class="{cellPhoneInput: key === 'cellPhone' && errorPhone.includes(index)}" @change="errorPhone = []"/>
          </p>
          <i v-if="index !== 0" class="el-icon-remove" style="color: #F4516C;font-size: 30px;float: right;margin-left: 20px" @click="removeJoinPeople(index)" />
          <i v-if="joinParams.applyUserList.length < 3" class="el-icon-circle-plus" style="color: #13CE66; font-size: 30px;float: right" @click="addJoinPeople" />
        </div>
        <div class="submit-button" @click="handleSubmit">提交报名</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Apply',
  data() {
    return {
      errorPhone: [],
      isSuccess: false,
      options: [],
      loading: false,
      joinParamMapping: {
        'duty': '职务',
        'userName': '联系人',
        'cellPhone': '联系电话'
      },
      activityInfo: '',
      joinParams: {
        companyName: '',
        socialCreditCode: '',
        applyUserList: [
          {
            duty: '',
            userName: '',
            cellPhone: ''
          }
        ]
      }
    }
  },
  created() {
    this.getInfo()
    this.joinParams = {
      activityPkid: this.$route.query.pkid,
      companyName: '',
      socialCreditCode: '',
      applyUserList: [
        {
          duty: '',
          userName: '',
          cellPhone: ''
        }
      ]
    }
  },
  methods: {
    // querySearchAsync1(queryString, cb) {
    //   var restaurants = this.restaurants
    //   var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants
    //
    //   clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     cb(results);
    //   }, 3000 * Math.random());
    // },
    querySearchAsync(queryString, cb) {
      if (!['', null, undefined].includes(queryString)) {
        this.loading = true
        this.$get('/front/index/selectCompany', queryString).then(res => {
          this.loading = false
          this.options = res.data
          const _t = JSON.parse(JSON.stringify(res.data))
          const __t = _t.map(i => {
            return {
              value: i.company_name || ''
            }
          })
          cb(__t)
        })
      } else {
        this.loading = false
      }
    },
    // 输入失焦
    blurInput(e) {
      if (e.target.value.trim() !== '') {
        this.joinParams.companyName = e.target.value
      }
    },
    cancelReadOnly(onOff) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (!onOff) {
            const { select } = this.$refs
            const input = select.$el.querySelector('.el-input__inner')
            input.removeAttribute('readonly')
          }
        })
      })
    },
    addJoinPeople() {
      this.joinParams.applyUserList.push({
        duty: '',
        userName: '',
        cellPhone: ''
      })
    },
    removeJoinPeople(index) {
      this.joinParams.applyUserList.splice(index, 1)
    },
    handleSubmit() {
      if (this.joinParams.companyName === '') {
        return this.$message.warning('请填写公司名称 !')
      }
      if (this.joinParams.socialCreditCode === '') {
        return this.$message.warning('请填写社会信用统一代码 !')
      }
      if (this.joinParams.applyUserList) {
        const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
        for (let i = 0; i < this.joinParams.applyUserList.length; i++) {
          if (!this.joinParams.applyUserList[i].userName || !this.joinParams.applyUserList[i].duty || !this.joinParams.applyUserList[i].cellPhone) {
            return this.$message.warning('请完善报名人信息 !')
          }
          if (!reg.test(this.joinParams.applyUserList[i].cellPhone)) {
            this.errorPhone.push(i)
          }
        }
        if (this.errorPhone.length > 0) {
          return this.$message.warning('请输入正确的联系电话 !')
        }
      }
      this.$post('/front/index/h5ApplyActivity', this.joinParams).then(res => {
        if (res) {
          this.isSuccess = true
        }
      })
    },
    handleChange(data) {
      console.log('choose', data)
      if (this.options.length > 0) {
        this.options.forEach(item => {
          if (item.company_name === data) {
            this.joinParams.socialCreditCode = item.company_code
          }
        })
      }
    },
    handleChangeAuto(data) {
      console.log('choose', data)
      data = data.value
      if (this.options.length > 0) {
        this.options.forEach(item => {
          if (item.company_name === data) {
            this.joinParams.socialCreditCode = item.company_code
          }
        })
      }
    },
    remoteMethod(keywords) {
      if (!['', null, undefined].includes(keywords)) {
        this.loading = true
        this.$get('/front/index/selectCompany', keywords).then(res => {
          this.loading = false
          this.options = res.data
        })
      }
    },
    getInfo() {
      this.$get('/front/index/activityInfo', this.$route.query.pkid).then(res => {
        if (res) {
          this.activityInfo = res
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.apply {
  padding: 3%;
  .success {
    width: 100%;
    margin-top: 50px;
    font-size: 50px;
    text-align: center;
    font-weight: 600;
    color: #409EFF
  }
  img {
    width: 50%;
  }
  .title {
    text-align: center;
    font-size: 25px;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .info {
    margin-top: 5px;
    span {
      font-size: 16px;
      font-weight: 600 !important;
    }
  }
  .content {
    margin: 10px auto 0 auto;
    .notice {
      width: 100%;
      font-weight: 500;
      color: #FF4040;
      text-align: center;
    }
    .red-star {
      font-size: 15px;
      font-weight: 600;
      color: red;
    }
    .join-people {
      padding: 5px 5px 40px 5px;
      margin-top: 20px;
      background-color: #F8F8F8;
      .join-item {
        margin-bottom: 10px;
      }
    }
    .submit-button {
      width: 100%;
      height: 40px;
      line-height: 40px;
      margin: 30px auto 0 auto;
      background: #EA5504;
      border-radius: 2px;
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      cursor: pointer;
    }
    .submit-button:hover {
      opacity: 0.8;
    }
  }
}

</style>
<style lang="scss">
.el-input.cellPhoneInput {
.el-input__inner {
  border: 1px solid red;
}
}
</style>
